import React, { useCallback, useEffect, useState } from 'react';
import styles from './SubtitlesLanguageCheckbox.module.scss';
import cx from 'classnames';
import LanguageItem from '../LanguageItem/LanguageItem';
import RadioButton from '../../../../components/RadioButton/RadioButton';

const SubtitlesLanguageCheckbox = ({ option, availableLanguages, subtitlesInPlayer, setSubtitlesInPlayer }) => {
  const [isVisible, setIsVisible] = useState(option.visible);
  const [isChanged, setIsChanged] = useState(false);
  const [languageData, setLanguageData] = useState({ name: '', src: '' });

  const handleCheckboxClick = useCallback(
    e => {
      e.stopPropagation();
      handleSelect(option);
    },
    [option]
  );

  useEffect(() => {
    setLanguageData(availableLanguages.find(el => el.id === option.language));
  }, []);

  useEffect(() => {
    setIsVisible(option.visible);
  }, [option]);

  const handleSelect = () => {
    setSubtitlesInPlayer(
      subtitlesInPlayer.map(item =>
        item.language === option.language ? { ...item, visible: !isVisible, isChanged: !isChanged } : item
      )
    );
    setIsVisible(!isVisible);
    setIsChanged(!isChanged);
  };

  return (
    <div className={styles.option} onClick={() => handleSelect(option)}>
      <RadioButton checked={isVisible} className={cx(styles.radiobutton)} variant={'secondary'} />
      <LanguageItem name={languageData?.name} src={languageData?.src} />
    </div>
  );
};

export default SubtitlesLanguageCheckbox;
